/**
 * Normalize Axios errors from DMS APIs (403 + errorResponse shape with details).
 */
export function getDmsApiErrorMessage(err, fallback = "Something went wrong") {
  const status = err?.response?.status;
  const d = err?.response?.data;
  if (d && typeof d === "object") {
    const detail = d.error?.details;
    if (typeof detail === "string" && detail.trim()) return detail.trim();
    if (typeof d.message === "string" && d.message.trim()) return d.message.trim();
  }
  if (status === 403) {
    return "You do not have access to this data. If you are on a sales team, choose an allowed distributor.";
  }
  if (typeof err?.message === "string" && err.message.trim()) return err.message.trim();
  return fallback;
}
